import { useState } from "react";
import { FileSearch } from "lucide-react";
import { useGetTransactionsQuery } from "../../redux/services/Wallet";
import { cn } from "../../utils/cn";
import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";
import FleetrifyBlockSkeleton from "../Loading/BlockSkeleton";
import { formatDateTime } from "../../utils/helper";
import TransactionAmountCell from "./TransactionAmountCell";

const TransactionHistoryTable = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isLoading, isFetching, isError } = useGetTransactionsQuery({
    page: currentPage,
    per_page: 10,
  });

  //  Use correct path for paginated data
  const transactions = data?.data?.data ?? [];

  const columns: Column[] = [
    {
      label: "Date",
      key: "created_at",
      render: (value) => formatDateTime(value),
    },
    {
      label: "Type",
      key: "transaction_type",
      render: (value) => value || "-",
    },
    {
      label: "Amount",
      key: "amount",
      render: (value, row) => (
        <TransactionAmountCell amount={value} totalFee={row?.total_fee} />
      ),
    },
    {
      label: "Description",
      key: "description",
      render: (value) => value || "-",
    },
    {
      label: "Status",
      key: "status",
      render: (value) => (
        <span
          className={cn(
            "px-2 py-1 rounded text-xs font-medium",
            value === "success"
              ? "bg-green-100 text-green-800"
              : value === "pending"
              ? "bg-yellow-100 text-yellow-800"
              : value === "Processing"
              ? "bg-blue-100 text-blue-800"
              : "bg-red-100 text-red-800"
          )}
        >
          {value || "-"}
        </span>
      ),
    },
  ];


  if (isLoading)
    return <FleetrifyBlockSkeleton lines={6} className="mt-4" />;

  if (isError)
    return <p className="text-red-500 mt-4">Failed to load transactions.</p>;

  if (!transactions.length)
    return (
      <div className="flex flex-col items-center justify-center bg-gray-50 border border-gray-200 rounded-lg p-10 mt-6 shadow-sm mx-4">
        <div className="bg-gray-100 p-4 rounded-full mb-4">
          <FileSearch className="h-10 w-10 text-gray-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-700 mb-1">
          No Transactions Found
        </h3>
        <p className="text-sm text-gray-500 max-w-sm text-center">
          You don’t have any wallet transactions yet. Once you fund or make a
          payment, your transaction history will appear here.
        </p>
      </div>
    );
  return (
    <div>
      <FleetrifyCustomTable
        tableTitle="Recent Transactions"
        data={transactions}
        columns={columns}
        isLoading={isFetching}
        checkbox={false}
        pageSize={10}
        total={data?.data?.total ?? 0}
        currentPage={data?.data?.current_page ?? currentPage}
        lastPage={data?.data?.last_page ?? 1}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default TransactionHistoryTable;
